import React, { useState,useEffect } from "react";
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';

// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col, Button } from "reactstrap";
import {getAll,openDoorAPI,getClosedDays} from 'network/ApiAxios'
import axios from 'axios'


const Header = (props)=>{
  const [jobapp, setjobapp] = useState(0);
  const [jobnextfase, setjobnextfase] = useState(0);
  const [doorOpen, setDoorOpen] = useState('primary');
  const [posDays, setPosDays] = useState();
  useEffect(() => {
    jobAppCount()
    closedDay()
  }, []);

  const jobAppCount = async ()=>{
    const {data} = await getAll("userTable");
    const count = data.users.filter((value)=>{
      return value.role === "jobapp" & value.sDate?.includes("2023")
    }).length
    const countNextFase = data.users.filter((value)=>{
      return value.nextfase & value.sDate?.includes("2023")
    }).length
    setjobapp(count)
    setjobnextfase(countNextFase)
    
  }

  const openDoor = async()=>{
    const resAxios = await openDoorAPI()
    if(resAxios.data.success){
      setDoorOpen('action')
    }else{
      setDoorOpen('error')
    }
  }

  const closedDay =async ()=>{
    const resp = await getClosedDays()
    if(resp.data.success){
      setPosDays(resp.data.bars)
    }
  }

  const compareDates= (date)=>{
    const tillDate = date + 86400000
    const todayDate = Date.parse(new Date())
    if(todayDate - tillDate > 86400000){
      return true
    }else{
      return false
    }
  }
    return (
      <>
        <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
          <Container fluid>
            <div className="header-body">
              {/* Card stats */}
              <Row>
                <Col lg="6" xl="3">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted"
                          >
                            Till Date
                          </CardTitle>
                          
                        </div>
                      </Row>
                        {posDays && Object.entries(posDays).map((bar)=>{
                          return<p  key={bar[0]}
                                style={{fontSize:'smaller',marginTop:'-15px'}} 
                                className={compareDates(bar[1]) ? 'bg-red' : 'bg-cyan'} 
                                >
                                  <span className=" text-uppercase text-blue bold font-weight-bold" > 
                                    {bar[0] =='albufeira' ? 'Albufeira 66' : bar[0]} : 
                                  </span> 
                                  {new Date(bar[1] + 86400000).toLocaleDateString('en-GB')} 
                                </p>
                        })}
                        <span className="text-danger mr-2">
                          Today: {new Date().toLocaleDateString('en-GB')}
                        </span>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6" xl="3">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            New users
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            2,356
                          </span>
                        </div>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                            <i className="fas fa-chart-pie" />
                          </div>
                        </Col>
                      </Row>
                      <p className="mt-3 mb-0 text-muted text-sm">
                        <span className="text-danger mr-2">
                          <i className="fas fa-arrow-down" /> 3.48%
                        </span>{" "}
                        <span className="text-nowrap">Since last week</span>
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6" xl="3">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            Job Entries
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">{jobapp}</span>
                        </div>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                            <i className="fas fa-users" />
                          </div>
                        </Col>
                      </Row>
                      <p className="mt-3 mb-0 text-muted text-sm" >
                        <span className="text-warning mr-2">
                          <i className="fas fa-arrow-right"  /> {jobnextfase} to Next Fase
                        </span>
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6" xl="3">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            Door Access
                          </CardTitle>
                          <Button onClick={openDoor} ><MeetingRoomIcon color={doorOpen} />Open Door</Button>
                        </div>
                        <Col className="col-auto" hidden>
                          <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                            <i className="fas fa-percent" />
                          </div>
                        </Col>
                      </Row>
                      <p className="mt-3 mb-0 text-muted text-sm" hidden>
                        <span className="text-success mr-2">
                          <i className="fas fa-arrow-up" /> 12%
                        </span>{" "}
                        <span className="text-nowrap">Since last month</span>
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </>
    );
  
}

export default Header;
